<template>
  <div>
    <canvas ref="canvas"></canvas>
    <v-divider/>
    <v-responsive style="height: 80px;">
      <v-container fill-height>
        <v-layout align-center>
          <v-flex text-xs-center>
            <v-list>
              <v-list-tile>
                <v-list-tile-avatar color="primary">
                  <span class="white--text headline">¥</span>
                </v-list-tile-avatar>
                <v-list-tile-content>
                  <v-list-tile-sub-title>
                    <span>{{currentLabel1}}</span>
                    <span class="subheading" style="color: #0d47a1">{{currentData1}}</span>
                    <span> 项</span>
                  </v-list-tile-sub-title>
                  <v-list-tile-sub-title>
                    <span>{{currentLabel0}}</span>
                    <span class="subheading" style="color: #0d47a1">{{currentData0}}</span>
                    <span> 万元</span>
                  </v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
          </v-flex>
        </v-layout>
      </v-container>
    </v-responsive>
  </div>
</template>

<script>
  import {Bar, Line, mixins} from 'vue-chartjs'

  const uri = '/api/proj/report/nsfc-by-year';

  export default {
    extends: Bar,
    mixins: [mixins.reactiveData],
    data() {
      return {
        chartData: null,
        options: {
          responsive: true,
          title: {
            display: true,
            text: '国家基金年度统计'
          },
          tooltips: {
            mode: 'index',
            intersect: false,
          },
          hover: {
            mode: 'nearest',
            intersect: true
          },
          scales: {
            xAxes: [{
              display: true,
              scaleLabel: {
                display: false,
                labelString: '年度'
              }
            }],
            yAxes: [{
              type: 'linear',
              display: true,
              position: 'left',
              ticks: {
                beginAtZero: true,
              },
              scaleLabel: {
                display: true,
                labelString: '数量'
              },
              id: 'y-axis-1',
            }, {
              type: 'linear',
              display: true,
              position: 'right',
              ticks: {
                beginAtZero: true,
              },
              scaleLabel: {
                display: true,
                labelString: '合同额（万元）'
              },
              id: 'y-axis-2',

              // grid line settings
              gridLines: {
                drawOnChartArea: false,
              },
            }]
          }
        }
      }
    },
    created() {
      this.axios.get(uri).then(
        rsp => {
          this.chartData = rsp.data;
          this.loading = false;
        }
      )
    },
    mounted() {
      this.renderChart(this.chartData, this.options)
    },
    computed: {
      currentLabel0() {
        return this.chartData ? `${this.chartData.labels.slice(-1)[0]}年国家基金${this.chartData.datasets[0].label}` : ""
      },
      currentData0() {
        return this.chartData ? `${Math.round(this.chartData.datasets[0].data.slice(-1)[0] * 100) / 100}` : ""
      },
      currentLabel1() {
        return this.chartData ? `${this.chartData.labels.slice(-1)[0]}年国家基金${this.chartData.datasets[1].label}` : ""
      },
      currentData1() {
        return this.chartData ? `${Math.round(this.chartData.datasets[1].data.slice(-1)[0] * 100) / 100}` : ""
      }
    }
  }
</script>

<style scoped>

</style>
